/**
 * Video.js plugin "addLocalizations"
 *
 * The plugin adds labels to player DOM via CSS selector and make it localizable.
 *
 * @function addLocalizations
 * @param
 */

import { additionalLocalizations } from './additional-localizations';

const pluginAddLocalizations = videojs => {
  videojs.registerPlugin('addLocalizations', function (player) {
    player.ready(() => {
      if (additionalLocalizations.length > 0) {
        additionalLocalizations.forEach(item => {
          player.el_.querySelectorAll(item.selector).forEach(el => {
            el.innerText = player.localize(item.translation);
          });
        });
      }
    });
  });
};

export { pluginAddLocalizations };
